export const ViewMaterialAndTruckConstants = {
    MATERIAL_TAB_NAME: "Material Details",
    MATERIAL_TAB_KEY: "materialOrdersTab",
    TRUCK_TAB_NAME: "Truck Details",
    TRUCK_TAB_KEY: "truckOrdersTab",
    BID_TOOL_WIDTH: "95%",
    BID_TOOL_HEIGHT: "100vh",
}